<template>
  <div id="combinations-editor">
    <div class="combination standard" v-for="(combination, i) in combinations" :key="'s'+i">
      <button class="remove-group" @click="removeGroup(i)">－</button>
      <combination v-model="combinations[i]" @enter="addCombination"></combination>
    </div>
    <button @click="addCombination">＋</button>
  </div>  
</template>

<style lang="stylus" scoped>
#combinations-editor
  display flex
  flex-direction column
  &>.combination
    display grid
    gap 5px
    grid-template-columns auto 1fr
    margin 5px 0
    align-items center
@media (max-width:767px)
  #combinations-editor
    &>.combination
      margin-bottom 15px
</style>

<script>
import Combination from './Combination'

export default {
  name: 'CombinationsEditor',
  props: {
    value: Array,
  },
  computed: {
    combinations: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    removeItem(group, n) {
      group.splice(n, 1)
    },
    addItem(group) {
      group.push('')
      this.$nextTick(() => {
        for (let e = document.activeElement; e !== document.rootElement; e = e.parentElement) {
          if (e.matches('.group')) {
            let inputs = e.querySelectorAll('input[type="text"]')
            if (inputs.length > 0) inputs[inputs.length - 1].focus()
          }
        }
      })
    },
    addCombination() {
      this.combinations.push([''])
      this.$nextTick(() => {
        let inputs = this.$el.querySelectorAll('.combination.standard input[type="text"]')
        if (inputs.length > 0) inputs[inputs.length - 1].focus()
      })
    },
    removeGroup(i) {
      this.combinations.splice(i, 1)
    },
  },
  components: { Combination }
}
</script>
